import type { ILoadInfo } from '@/service/info';

/** vLLM LoRA alias: active persona wins over stale load identity. */
export function resolveLoraModelId(
  loadInfo: ILoadInfo | null | undefined,
  activePersonaId?: string | null
): string {
  const persona = (activePersonaId || '').trim().toLowerCase();
  if (persona) {
    return persona;
  }
  const slug = (loadInfo?.name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
  const stored = (loadInfo?.lora_model_id || '').trim();
  if (slug && stored && slug !== stored) {
    return slug;
  }
  return stored || slug || 'default';
}
